import { SocketType } from "../contants/Socket.Type";
const initialState = {
  notification: [],
  kitchen: [],
  bar: [],
  cake_Room: [],
  status: false,
};
export const socketReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SocketType.SET_SOCKET_STATUS:
      return { ...state, initialState: payload.status };
    case SocketType.SET_SOCKET_DATA:
      return { ...state, initialState: payload.Kitchen };
    default:
      return state;
  }
};
